export const datePopperConfig = {
    placement: "bottom-start",
    modifiers: [
        {
            name: "flip",
            enabled: false, // prevent flipping above
        },
        {
            name: "preventOverflow",
            options: {
                rootBoundary: "viewport",
            },
        },
    ],
};